var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-flex",
    { staticStyle: { "text-align": "center" } },
    [
      _c(
        "v-btn",
        {
          staticClass: "log-button",
          attrs: { fab: "", color: _vm.getColor("lighten-2") },
          on: {
            click: function ($event) {
              return _vm.toggle()
            },
          },
        },
        [
          _c(
            "transition",
            { attrs: { name: "slide-fade", mode: "out-in" } },
            [
              _vm.states.loadingResults
                ? _c("v-progress-circular", {
                    attrs: { color: _vm.getColor(), indeterminate: "" },
                  })
                : _vm.states.errorResults
                ? _c("v-icon", { attrs: { color: _vm.getColor() } }, [
                    _vm._v("help_outline"),
                  ])
                : _c("span", { key: _vm.count }, [
                    _vm._v(_vm._s(_vm.numberWithCommas(_vm.count))),
                  ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "spaced-label-2" }, [
        _c(
          "span",
          {
            staticClass: "clickable",
            on: {
              click: function ($event) {
                return _vm.toggle()
              },
            },
          },
          [
            _c("v-icon", { attrs: { small: "" } }, [
              _vm._v(_vm._s(this.active ? "visibility" : "visibility_off")),
            ]),
            _vm._v("\n      " + _vm._s(_vm.label) + "s\n    "),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }